module.exports = __webpack_public_path__ + "static/assets/35cf878e4402b6a57b7fd9c06301f21a.jpg";